import { useLocation } from "react-router-dom";
import { Badge, Card, CardBody, CardHeader, Table } from "reactstrap";
import BreadCrumbs from "../../../../components/BreadCrumbs";
import { MenuItem } from "../../../../redux/menuSlice";
import "./index.css";
import { Portion } from "../../../../redux/setMenuSlice";
import { getImageUrl } from "../../../../dummyData/FoodAttributes";

const ViewMenuItem = () => {
  const location = useLocation();
  const item = location.state as MenuItem;

  return (
    <>
      <BreadCrumbs hasSubMenus={false} />
      <div className="menuitem-view-container">
        <Card className="menuitem-view-card ">
          <CardHeader className="menuitem-viewcard-card-header">
            <h5>Menu Item Details</h5>
          </CardHeader>
          <CardBody>
            <Table responsive>
              <tbody>
                <tr>
                  <th>Images</th>
                  <td>
                    {item.imageUrl.map((url: string, index: number) => (
                      <img
                        key={index}
                        src={url}
                        alt={`${item.displayName} - ${index + 1}`}
                        width={"100px"}
                        height={"100px"}
                        style={{
                          marginRight: "10px",
                          marginBottom: "10px",
                          borderRadius: "15px",
                        }}
                      />
                    ))}
                  </td>
                </tr>
                <tr>
                  <th>Name</th>
                  <td>{item.displayName}</td>
                </tr>
                <tr>
                  <th>Price (Rs.)</th>
                  <td>{item.price.toFixed(2)}</td>
                </tr>
                <tr>
                  <th>Item Status</th>
                  <td>
                    <Badge
                      color={item.isAvailable ? "success" : "secondary"}
                      className="px-2 py-1"
                    >
                      <div style={{ fontSize: 12 }}>
                        {" "}
                        {item.isAvailable ? "Active" : "Inactive"}{" "}
                      </div>
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <th>Description</th>
                  <td>{item.description}</td>
                </tr>

                <tr>
                  <th>Category</th>
                  <td>{item.category}</td>
                </tr>
                <tr>
                  <th>Customizable</th>
                  <td>
                    <Badge
                      color={item.isCustomMenuItem ? "success" : "secondary"}
                      className="px-2 py-1"
                    >
                      <div style={{ fontSize: 12 }}>
                        {" "}
                        {item.isCustomMenuItem ? "Active" : "Inactive"}{" "}
                      </div>
                    </Badge>
                  </td>
                </tr>
                {item.isCustomMenuItem && (
                  <tr>
                    <th>Custom Menu Type</th>
                    <td>{item?.customMenuItemSection}</td>
                  </tr>
                )}

                <tr>
                  <th>Preparing Time (Mins)</th>
                  <td>{item.preparingTime} Mins</td>
                </tr>
                {item.supportsPreOrdering !== undefined && (
                  <tr>
                    <th>Supports Pre-Ordering</th>
                    <td>
                      <Badge
                        color={
                          item.supportsPreOrdering ? "success" : "secondary"
                        }
                        className="px-2 py-1"
                      >
                        <div style={{ fontSize: 12 }}>
                          {item.supportsPreOrdering ? "Yes" : "No"}
                        </div>
                      </Badge>
                    </td>
                  </tr>
                )}
                {item.supportPortionSizes !== undefined && (
                  <tr>
                    <th>Supports Portion Sizes</th>
                    <td>
                      <Badge
                        color={
                          item.supportPortionSizes ? "success" : "secondary"
                        }
                        className="px-2 py-1"
                      >
                        <div style={{ fontSize: 12 }}>
                          {item.supportPortionSizes ? "Yes" : "No"}
                        </div>
                      </Badge>
                    </td>
                  </tr>
                )}

                {item.allergenInformation &&
                  item.allergenInformation.length > 0 && (
                    <tr>
                      <th>Allergen Information</th>
                      <td>
                        {item.allergenInformation.map((allergen, index) => (
                          <span
                            key={index}
                            className="d-inline-flex align-items-center"
                          >
                            <img
                              src={getImageUrl(allergen)}
                              alt={allergen}
                              width={"20px"}
                              height={"20px"}
                              className=" ms-2"
                            />
                          </span>
                        ))}
                      </td>
                    </tr>
                  )}

                {item.foodAttributes && item.foodAttributes.length > 0 && (
                  <tr>
                    <th>Food Attributes</th>
                    <td>
                      {item.foodAttributes.map((attribute, index) => (
                        <span
                          key={index}
                          className="d-inline-flex align-items-center"
                        >
                          <img
                            src={getImageUrl(attribute)}
                            alt={attribute}
                            width={"20px"}
                            height={"20px"}
                            className="ms-2"
                          />
                        </span>
                      ))}
                    </td>
                  </tr>
                )}
                <br />
                {item.portions && item.portions.length > 0 && (
                  <tr>
                    <th>Food Attributes</th>
                    <Table bordered className="small-portions-table">
                      <thead>
                        <tr>
                          <th>Size</th>
                          <th>Price (Rs.)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {item.portions.map(
                          (portion: Portion, index: number) => (
                            <tr key={index}>
                              <td>{portion.displayName}</td>
                              <td>{portion.additionalCost.toFixed(2)}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                  </tr>
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default ViewMenuItem;
